import { controllingSetDefaultPreset } from '../../../../store/controlling/actions';
import { globalUpdatePresetOrProperty } from '../../../../store/global/actions';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useDefault = (id, type) => {
  const defaultValues = useSelector((state) => state.default.presets[id]);

  const dispatch = useDispatch();

  const isDirty = useSelector((state) => {
    const currentPreset = state.presets[id];
    const defaultPreset = state.default.presets[id];

    const keys = Object.keys(currentPreset);

    for (let i = 0; i < keys.length; i++) {
      if (currentPreset[keys[i]] !== defaultPreset[keys[i]]) {
        return true;
      }
    }

    return false;
  });

  const revert = useCallback(() => {
    const key = `presets.${id}`;

    // eslint-disable-next-line no-restricted-globals
    const conf = confirm('Are you sure?');

    if (conf) {
      dispatch(globalUpdatePresetOrProperty(key, defaultValues));

      dispatch(controllingSetDefaultPreset(type, id));
    }
  }, [defaultValues, dispatch, id, type]);

  return {
    isDirty,
    revert,
  };
};

export default useDefault;
